import type { IconName } from '@/app/elements/svg/loader';

export enum FILTER_GROUP {
    THEME = 'theme',
    FEATURE = 'feature',
    GENRE = 'genre',
    STUDIO = 'studio'
}

export type FilterOption = {
    title: string;
    uids: string[]; // Keep it string of ids for consistency, we have filters that refer to group of uids, ex: Studios
};

export type FilterGroup = {
    title: string;
    icon: IconName;
    options: FilterOption[];
    key: FILTER_GROUP;
};

export type SelectedFilters = {
    [FILTER_GROUP.THEME]: FilterOption[];
    [FILTER_GROUP.FEATURE]: FilterOption[];
    [FILTER_GROUP.GENRE]: FilterOption[];
    [FILTER_GROUP.STUDIO]: FilterOption[];
};
